import { Course } from '../entities/course.entity';
import { ExamContent } from '../entities/exam-content.entity';
import { Folder } from '../entities/folder.entity';

export interface RateFormValue {
  rate: number;
  comment?: string;
}

export class RatePayload {
  rate: number;
  comment: string;

  constructor(formValue: RateFormValue) {
    this.rate = formValue.rate;
    this.comment = formValue.comment ? formValue.comment : '';
  }
}

export class CourseRatePayload extends RatePayload {
  courseId: string;

  constructor(formValue: RateFormValue, course: Course) {
    super(formValue);
    this.courseId = course.id;
  }
}

export class ExamContentRatePayload extends RatePayload {
  examContentId: string;

  constructor(formValue: RateFormValue, examContent: ExamContent) {
    super(formValue);
    this.examContentId = examContent.id;
  }
}

export class FolderRatePayload extends RatePayload {
  folderId: string;

  constructor(formValue: RateFormValue, folder: Folder) {
    super(formValue);
    this.folderId = folder.id;
  }
}
